import i18next from 'i18next';

export enum LoadCategory {
    'Round' = 0,
    'Pool' = 1,
    'Poc' = 2,
}

const categoryMap: Record<number, string> = {
    [LoadCategory.Round]: 'Round',
    [LoadCategory.Pool]: 'Pool',
    [LoadCategory.Poc]: 'POC FA',
};

export function getSelectOptionsEnumLoadCategory() {
    const enumOptions: any[] = [];

    const enumStrings = Object.keys(LoadCategory).filter(key =>
        Number.isNaN(Number(key)),
    );

    enumStrings.forEach((key: string) => {
        enumOptions.push({
            value: key,
            label: categoryMap[LoadCategory[key as keyof typeof LoadCategory]],
        });
    });

    return enumOptions;
}

export const getLoadCategoryOptions = () => {
    const categories = getSelectOptionsEnumLoadCategory();

    categories.forEach(c => {
        c.label = i18next.t(c.label);
        return c;
    });

    return categories;
};
